module.exports = __webpack_public_path__ + "static/media/branding2.1fd38da5.jpg";